import { FC } from "react";

const Conditional: FC<{ when: boolean }> = ({ when, children }) => (
  <>{when && children}</>
);

export default Conditional;
